import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

/**
 * Branded text/select prompt modal — used by PromptProvider.
 */
const PromptModal = ({
  show,
  onHide,
  onSubmit,
  title,
  body,
  label,
  defaultValue = '',
  placeholder = '',
  required = true,
  multiline = false,
  inputType = 'text',
  options = [],
  submitText = 'OK',
  cancelText = 'Cancel',
}) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    if (show) setValue(defaultValue);
  }, [show, defaultValue]);

  const trimmed = String(value).trim();
  const canSubmit = !required || trimmed.length > 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    onSubmit(inputType === 'select' ? value : (required ? trimmed : String(value)));
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton style={{ backgroundColor: 'var(--archon-blue-light)', color: 'white' }}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body style={{ backgroundColor: 'var(--archon-modal-soft-blue)' }}>
          {body && <p className="mb-3">{body}</p>}
          {label && <Form.Label>{label}</Form.Label>}
          {inputType === 'select' ? (
            <Form.Select value={value} onChange={(e) => setValue(e.target.value)} autoFocus>
              {options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Form.Select>
          ) : multiline ? (
            <Form.Control
              as="textarea"
              rows={3}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={placeholder}
              autoFocus
            />
          ) : (
            <Form.Control
              type="text"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={placeholder}
              autoFocus
            />
          )}
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: 'var(--archon-modal-soft-blue)' }}>
          <Button variant="secondary" onClick={onHide}>
            {cancelText}
          </Button>
          <Button variant="primary" type="submit" disabled={!canSubmit}>
            {submitText}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default PromptModal;
